import { Timestamp } from 'firebase/firestore';
import { IOpportunityRouteData, ITransactionOpportunity } from '../../sp-types/transactionOpportunityType';

export const mockOpportunityRouteData: Record<string, IOpportunityRouteData> = {
  route2: {
    id: 'route2',
    name: 'LME Rebar + Energy',
    color: '#19ceb8', // Example color
  },
  route1: {
    id: 'route1',
    name: 'Bush Scrap + Energy',
    color: '#858efc', // Example color
  },
  route3: {
    id: 'route3',
    name: 'LME Scrap + Energy',
    color: '#189ae3', // Example color
  },
};



export const transactionOpportunitiesMock: ITransactionOpportunity[] = [
  // Transaction 1
  {
    quantity: 15000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2023-10-05')),
      price: 840,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2024-05-09')),
      price: 810,
    },
    routesOptionData: [
      {
        routeId: 'route1',
        buyingPrice: 770,
        sellingPrice: 811,
      },
      {
        routeId: 'route2',
        buyingPrice: 796,
        sellingPrice: 813,
      },
      {
        routeId: 'route3',
        buyingPrice: 807,
        sellingPrice: 824,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 2
  {
    quantity: 12000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2023-07-06')),
      price: 900,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2024-02-13')),
      price: 860,
    },
    routesOptionData: [
      {
        routeId: 'route3',
        buyingPrice: 814,
        sellingPrice: 831,
      },
      {
        routeId: 'route2',
        buyingPrice: 822,
        sellingPrice: 816,
      },
      {
        routeId: 'route1',
        buyingPrice: 843,
        sellingPrice: 794,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 3
  {
    quantity: 15000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2023-08-08')),
      price: 870,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2024-01-11')),
      price: 860,
    },
    routesOptionData: [
      {
        routeId: 'route2',
        buyingPrice: 772,
        sellingPrice: 819,
      },
      {
        routeId: 'route1',
        buyingPrice: 820,
        sellingPrice: 847,
      },
      {
        routeId: 'route3',
        buyingPrice: 792,
        sellingPrice: 843,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 4
  {
    quantity: 11000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2023-03-06')),
      price: 900,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2023-10-26')),
      price: 830,
    },
    routesOptionData: [
      {
        routeId: 'route3',
        buyingPrice: 925,
        sellingPrice: 819,
      },
      {
        routeId: 'route2',
        buyingPrice: 980,
        sellingPrice: 794,
      },
      {
        routeId: 'route1',
        buyingPrice: 933,
        sellingPrice: 828,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 5
  {
    quantity: 14000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2023-02-01')),
      price: 900,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2023-08-10')),
      price: 870,
    },
    routesOptionData: [
      {
        routeId: 'route1',
        buyingPrice: 878,
        sellingPrice: 840,
      },
      {
        routeId: 'route2',
        buyingPrice: 951,
        sellingPrice: 789,
      },
      {
        routeId: 'route3',
        buyingPrice: 925,
        sellingPrice: 804,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 6
  {
    quantity: 9000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2022-11-09')),
      price: 975,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2023-05-22')),
      price: 940,
    },
    routesOptionData: [
      {
        routeId: 'route1',
        buyingPrice: 865,
        sellingPrice: 843,
      },
      {
        routeId: 'route2',
        buyingPrice: 936,
        sellingPrice: 835,
      },

      {
        routeId: 'route3',
        buyingPrice: 914,
        sellingPrice: 801,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 7
  {
    quantity: 11000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2022-01-10')),
      price: 1030,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2022-05-13')),
      price: 1130,
    },
    routesOptionData: [
      {
        routeId: 'route1',
        buyingPrice: 894,
        sellingPrice: 1136,
      },
      {
        routeId: 'route2',
        buyingPrice: 937,
        sellingPrice: 1120,
      },

      {
        routeId: 'route3',
        buyingPrice: 913,
        sellingPrice: 1095,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 8
  {
    quantity: 13000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2021-09-23')),
      price: 985,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2022-05-09')),
      price: 1130,
    },
    routesOptionData: [
      {
        routeId: 'route2',
        buyingPrice: 905,
        sellingPrice: 1136,
      },
      {
        routeId: 'route1',
        buyingPrice: 951,
        sellingPrice: 1171,
      },
      {
        routeId: 'route3',
        buyingPrice: 914,
        sellingPrice: 1131,
      },
    ],
    formulaId: 'HRCc1',
  },
  // Transaction 9
  {
    quantity: 12000,
    buyByIndex: {
      date: Timestamp.fromDate(new Date('2020-12-15')),
      price: 680,
    },
    sellByIndex: {
      date: Timestamp.fromDate(new Date('2021-05-13')),
      price: 810,
    },
    routesOptionData: [
      {
        routeId: 'route1',
        buyingPrice: 764,
        sellingPrice: 816,
      },
      {
        routeId: 'route2',
        buyingPrice: 774,
        sellingPrice: 815,
      },

      {
        routeId: 'route3',
        buyingPrice: 789,
        sellingPrice: 824,
      },
    ],
    formulaId: 'HRCc1',
  },
];

export const transactionOpportunitiesMockWUndefined: ITransactionOpportunity[] = transactionOpportunitiesMock.map(
  (item) => ({ ...item, sellByIndex: undefined }),
);
